import { UIText3 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './ChatArchiveInfo.css';

export const ChatArchiveInfo = () => {
  return (
    <div className={styles['container']}>
      <UIText3 color="text-secondary-default">Напишите что-нибудь, и чат вернётся во «Все сообщения»</UIText3>
    </div>
  );
};
